import { render, staticRenderFns } from "./setAdmin.vue?vue&type=template&id=356495cd&"
import script from "./setAdmin.vue?vue&type=script&lang=js&"
export * from "./setAdmin.vue?vue&type=script&lang=js&"
import style0 from "./setAdmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports